var products = [{
  id: 'appoptics',
  title: 'AppOptics',
  description: 'Infrastructure and application performance monitoring',
  url: {
    homepage: 'https://appoptics.com',
    contact: 'https://www.appoptics.com/contact',
    signup: {
      staging: 'https://my-stg.appoptics.com/sign_up',
      production: 'https://my.appoptics.com/sign_up'
    },
    login: {
      staging: 'https://my-stg.appoptics.com',
      production: 'https://my.appoptics.com'
    }
  }
}, {
  id: 'loggly',
  title: 'Loggly',
  description: 'High-volume log aggregation, analytics, and visualization',
  url: {
    homepage: 'https://loggly.com/product/',
    contact: 'https://www.loggly.com/docs-index/',
    signup: {
      staging: 'https://www-staging.loggly.com/signup/',
      production: 'https://www.loggly.com/signup/'
    },
    login: {
      staging: 'https://app.gen3.qa.loggly.net/sso/oidc/swicus/app_switch',
      production: 'https://app.loggly.com/sso/oidc/swicus/app_switch'
    }
  }
}, {
  id: 'papertrail',
  title: 'Papertrail',
  description: 'Real-time log tailing, searching, and troubleshooting',
  url: {
    homepage: 'https://papertrailapp.com',
    contact: 'https://papertrailapp.com/plans/contact',
    signup: {
      staging: 'https://staging.papertrailapp.com/signup?plan=free',
      production: 'https://papertrailapp.com/signup?plan=free'
    },
    login: {
      staging: 'https://staging.papertrailapp.com/app-switch',
      production: 'https://papertrailapp.com/app-switch'
    }
  }
}, {
  id: 'pingdom',
  title: 'Pingdom',
  description: 'Web application performance and user experience monitoring',
  url: {
    homepage: 'https://pingdom.com',
    contact: 'https://www.pingdom.com/company/contact',
    signup: {
      staging: 'https://pingdomstg.wpengine.com/sign-up/',
      production: 'https://pingdom.com/signup'
    },
    login: {
      staging: 'https://st-my.pingdom.com',
      production: 'https://my.pingdom.com'
    }
  }
}];
export default products;
export function getProducts(hasIntegratedExperience, hasPingdomConvergence) {
  /**
   * We don't want to show AppOptics or Loggly as independent products when
   * integrated experience is enabled.
   */
  if (hasIntegratedExperience && hasPingdomConvergence) {
    return [products[2]];
  } else if (hasIntegratedExperience) {
    return products.slice(2);
  } else {
    return products;
  }
}